// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__1jufD","amount":"Amount_amount__xc652","tip":"Amount_tip__3AvW8","tipHeader":"Amount_tipHeader__2kDk3","tipsWrap":"Amount_tipsWrap__IUc_Z"};